export const ACCOUNT_STATEMENT = "ACCOUNT_STATEMENT";
export const WITHDRAW_LIST = "WITHDRAW_LIST";
export const BONUS_LISTING = "BONUS_LISTING";
export const ALL_GATEWAYS = "ALL_GATEWAYS";
export const SELECTED_GATEWAY = "SELECTED_GATEWAY";
export const PLAYER_BANK_DETAILS = "PLAYER_BANK_DETAILS";
